export default __webpack_public_path__ + "static/media/leverage-point-innovations-image.b4516c97.jpg";